export var AsyncType;
(function (AsyncType) {
    AsyncType["START"] = "async/start";
    AsyncType["SUCCESS"] = "async/success";
    AsyncType["ERROR"] = "async/error";
    AsyncType["INITIAL"] = "async/initial";
})(AsyncType || (AsyncType = {}));
export var AsyncStatus;
(function (AsyncStatus) {
    AsyncStatus["INITIAL"] = "initial";
    AsyncStatus["PENDING"] = "pending";
    AsyncStatus["SUCCESS"] = "success";
    AsyncStatus["ERROR"] = "error";
})(AsyncStatus || (AsyncStatus = {}));
